import { observer } from 'mobx-react';
import { FC } from 'react';
import { Label } from '../../../../../ types';
import * as styles from './index.module.scss';
import { $class } from '../../../../../../utils';
import { Flex } from 'antd';

interface IProps {
  labels: Label[];
}

const LabelList: FC<IProps> = ({ labels }) => {
  return (
    <Flex align="center" gap={8} wrap>
      {labels && labels.length > 0
        ? labels.map((label, index) => (
            <p key={index} className={$class(styles.label, styles[label.style])}>
              {label.caption}
            </p>
          ))
        : null}
    </Flex>
  );
};

export default observer(LabelList);
